(function () {
  // flag for debugging
  window.__VARIANT_URL_SYNC_LOADED__ = true;

  function updateVariantUrl(variantId) {
    if (!variantId) return;
    try {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', String(variantId));
      window.history.replaceState({ variantId }, '', url.toString());
    } catch (e) {
      // fallback (rare)
      const base = window.location.href.split('?')[0];
      window.history.replaceState({}, '', base + '?variant=' + variantId);
    }
  }

  function getVariantIdFromTarget(target) {
    if (!target) return null;

    // If user clicked input directly
    if (target.matches('input[type="radio"]') && target.value) return target.value;

    // If user clicked the label/card, find the radio inside
    const card = target.closest('.variant-card, .product-options__value, .product-options__value-text, .product-options');
    if (card) {
      const radio = card.querySelector('input[type="radio"]:checked') || card.querySelector('input[type="radio"]');
      if (radio && radio.value) return radio.value;
    }

    // If user clicked label that is FOR input
    const label = target.closest('label');
    if (label) {
      const forId = label.getAttribute('for');
      if (forId) {
        const radio = document.getElementById(forId);
        if (radio && radio.value) return radio.value;
      }
      const radioInside = label.querySelector('input[type="radio"]');
      if (radioInside && radioInside.value) return radioInside.value;
    }

    return null;
  }

  // Capture click (covers themes where change doesn't fire)
  document.addEventListener('click', function (e) {
    const variantId = getVariantIdFromTarget(e.target);
    if (!variantId) return;

    // let theme finish selecting variant, then update URL
    setTimeout(function () {
      // re-read checked radio if possible (more accurate)
      const checked = document.querySelector('.variant-card__radio:checked, .product-options input[type="radio"]:checked');
      updateVariantUrl((checked && checked.value) || variantId);
    }, 0);
  }, true);

  // Also listen to change (normal behavior)
  document.addEventListener('change', function (e) {
    const variantId = getVariantIdFromTarget(e.target);
    if (!variantId) return;
    updateVariantUrl(variantId);
  }, true);

  // Support common custom events (if theme emits them)
  ['variant:change','variant:changed','product:variant-change','product:variantChanged'].forEach(function(evt){
    document.addEventListener(evt, function (e) {
      const v = e.detail && (e.detail.variant || e.detail);
      if (v && v.id) updateVariantUrl(v.id);
    });
  });

})();
